import styles from './Header.module.scss';
import {Logo, Roll, Socials} from "../../components";

export const Header = () => {
    return (
        <header className={styles.header}>
            <Logo/>
            <div className={styles.string}>
                <Roll/>
            </div>
            <div className={styles.socials}>
                <Socials/>
            </div>
        </header>
    )
}